import React from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';
import { orderBy as _orderBy, isEmpty as _isEmpty, get as _get } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import FormTextarea from 'components/forms/FormTextarea';

class ServiceRequestDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      commentInput: '',
    };
  }

  getRowIndicatorStyle = serviceRequest => {
    if (serviceRequest.action_required) {
      return { borderLeft: '10px solid #e03a3a' };
    }

    if (!_isEmpty(serviceRequest.resubmission_date) && moment(serviceRequest.resubmission_date).isBefore(moment())) {
      return { borderLeft: '10px solid #ffa000' };
    }

    return { borderLeft: '10px solid #e0e0e0' };
  };

  addComment = content => {
    const { data, onSubmit, onServiceRequestChanged } = this.props;

    const submitData = { ...data };
    submitData.comments = submitData.comments.slice();
    submitData.comments.push({ content });

    onSubmit(data.id, submitData);

    if (onServiceRequestChanged) {
      onServiceRequestChanged(submitData);
    }
  };

  getServiceContractHint = serviceRequest => {
    if (serviceRequest.service_contract_active === 'Ja') {
      return '(aktiv)';
    }

    if (serviceRequest.service_contract_active === 'Nein') {
      return '(inaktiv)';
    }

    return '';
  };

  render() {
    const {
      intl: { messages },
      projectConfig,
      user,
      data,
      colSpan,
    } = this.props;

    return (
      <tr class="row-details">
        <td colSpan={colSpan} style={this.getRowIndicatorStyle(data)}>
          <Row>
            <Col xs={12} md={12} lg={4}>
              <div class="panel panel-transparent">
                <div class="panel-body no-padding">
                  <h4>{messages.sad.car_data}</h4>
                  <div>
                    <Table responsive hover condensed>
                      <tbody>
                        <tr>
                          <td>{messages.license_plate_number}</td>
                          <td>{_isEmpty(data.license_plate) ? '-' : data.license_plate}</td>
                        </tr>
                        <tr>
                          <td>{messages.sad.model_name}</td>
                          <td>{_isEmpty(data.model) ? '-' : data.model}</td>
                        </tr>
                        <tr>
                          <td>{messages.mileage}</td>
                          <td>{data.mileage >= 0 ? <FormattedNumber value={data.mileage} style="decimal" /> : ''}</td>
                        </tr>
                        <tr>
                          <td>Servicevertrag-Nr.</td>
                          <td>
                            {_isEmpty(data.service_contract_number) ? '-' : data.service_contract_number}{' '}
                            {this.getServiceContractHint(data)}
                          </td>
                        </tr>
                        <tr>
                          <td>Servicevertrag-Typ</td>
                          <td>{_isEmpty(data.service_contract_type) ? '-' : data.service_contract_type}</td>
                        </tr>
                        <tr>
                          <td>Servicevertrag-Zeitraum</td>
                          <td>
                            {_isEmpty(data.service_contract_startdate) ? (
                              '?'
                            ) : (
                              <FormattedDate
                                value={
                                  new Date(moment.tz(data.service_contract_startdate, 'UTC').tz(user.profile.timezone))
                                }
                              />
                            )}{' '}
                            -{' '}
                            {_isEmpty(data.service_contract_enddate) ? (
                              '?'
                            ) : (
                              <FormattedDate
                                value={
                                  new Date(moment.tz(data.service_contract_enddate, 'UTC').tz(user.profile.timezone))
                                }
                              />
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Servicevertrag-Laufleistung</td>
                          <td>
                            {_isEmpty(data.service_contract_start_mileage) ? '?' : data.service_contract_start_mileage}
                            {' - '}
                            {_isEmpty(data.service_contract_end_mileage) ? '?' : data.service_contract_end_mileage}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={4}>
              <div class="panel panel-transparent">
                <div class="panel-body no-padding">
                  <h4>Allgemein</h4>
                  <div>
                    <Table responsive hover condensed>
                      <tbody>
                        <tr>
                          <td>Angebots-Nr.</td>
                          <td>{_isEmpty(data.offer_number) ? '-' : data.offer_number}</td>
                        </tr>
                        <tr>
                          <td>Mandant</td>
                          <td>{_isEmpty(data.client) ? '-' : data.client}</td>
                        </tr>
                        <tr>
                          <td>{messages.sad.discount}</td>
                          <td>
                            {data.discount >= 0 ? (
                              <FormattedNumber
                                value={data.discount}
                                style="currency"
                                currency={projectConfig.data.currency}
                              />
                            ) : (
                              '-'
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Gesamtbetrag</td>
                          <td>
                            {data.total ? (
                              <FormattedNumber
                                value={data.total}
                                style="currency"
                                currency={projectConfig.data.currency}
                              />
                            ) : (
                              '-'
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div class="panel panel-transparent">
                <div class="panel-body no-padding">
                  <h4>{messages.sad.notes}</h4>
                  <div>
                    <Table responsive hover condensed>
                      <tbody>
                        {_orderBy(data.comments, 'cdate', 'desc').map((comment, i) => {
                          return (
                            <tr key={i}>
                              <td style={{ width: '90px' }}>
                                <FormattedDate
                                  value={new Date(moment.tz(_get(comment, 'cdate'), 'UTC').tz(user.profile.timezone))}
                                />
                              </td>
                              <td style={{ width: '120px' }}>{_get(comment, 'creator_name')}</td>
                              <td>{_get(comment, 'content')}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>

                    <div class="panel panel-transparent">
                      <div class="panel-body">
                        <div class="form-group-attached">
                          <FormTextarea
                            label={null}
                            name="commentInput"
                            rows={3}
                            onChange={(name, value) => this.setState({ [name]: value })}
                            disabled={this.props.formStatus.pending}
                          />
                        </div>

                        <div class="text-right m-t-10">
                          <Button
                            disabled={this.state.commentInput.length === 0 || this.props.formStatus.pending}
                            type="submit"
                            bsStyle="primary"
                            onClick={() => {
                              this.addComment(this.state.commentInput);
                            }}
                          >
                            <i
                              class={
                                'fa-fw ' +
                                (this.props.formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fas fa-save')
                              }
                            />{' '}
                            {messages.sad.note_save}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={4}>
              <div class="panel panel-transparent">
                <div class="panel-body no-padding">
                  <h4>{messages.client}</h4>
                  <div>
                    <Table responsive hover condensed>
                      <tbody>
                        <tr>
                          <td>{messages.client_name}</td>
                          <td>
                            {_isEmpty(data.customer_salutation) ? '' : data.customer_salutation}{' '}
                            {_isEmpty(data.customer_first_name) ? '' : data.customer_first_name}{' '}
                            {_isEmpty(data.customer_last_name) ? '' : data.customer_last_name}
                          </td>
                        </tr>
                        <tr>
                          <td>{messages.street}</td>
                          <td>{_isEmpty(data.customer_street) ? '-' : data.customer_street}</td>
                        </tr>
                        <tr>
                          <td>{messages.city}</td>
                          <td>
                            {_isEmpty(data.customer_zip_code) ? '' : data.customer_zip_code}{' '}
                            {_isEmpty(data.customer_city) ? '' : data.customer_city}
                          </td>
                        </tr>
                        <tr>
                          <td>Mail</td>
                          <td>{_isEmpty(data.customer_mail) ? '-' : data.customer_mail}</td>
                        </tr>
                        <tr>
                          <td>Telefon</td>
                          <td>{_isEmpty(data.customer_telephone) ? '-' : data.customer_telephone}</td>
                        </tr>
                        <tr>
                          <td>{messages.mobile_phone}</td>
                          <td>{_isEmpty(data.customer_mobile_phone) ? '-' : data.customer_mobile_phone}</td>
                        </tr>
                        <tr>
                          <td>{messages.language}</td>
                          <td>{_isEmpty(data.customer_language) ? '-' : data.customer_language}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (serviceRequestId, args) => {
      formStatusDispatchHelper(
        'serviceRequestEdit',
        '/api/plugin/connectme/servicerequests/' + serviceRequestId + '.json',
        args,
        'put',
        dispatch
      );
    },
    onFormSuccessfull: () => {
      dispatch(formReset('serviceRequestEdit'));
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    projectConfig: state.data.projectConfig,
    user: state.login.user,
    formStatus: state.formStatus.serviceRequestEdit,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ServiceRequestDetails)
  )
);
